import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Footer from '../Footer/Footer';
import './Info.css';
import { buildApiUrl } from '../../config/api.config';

const Info = () => {
  const [userDetails, setUserDetails] = useState({ name: "", email: "", id: "" });
  const [messages, setMessages] = useState([]);
  const [messagesLoading, setMessagesLoading] = useState(false);
  const [showMessages, setShowMessages] = useState(false);
  let navigate = useNavigate();

  const fetchUserDetails = async () => {
    try {
      const token = localStorage.getItem("token");
      if (!token) return null;
      
      const response = await fetch(buildApiUrl("/users/getuser"), {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "auth-token": token,
        },
      });
      if (response.ok) {
        return await response.json();
      } else {
        return null;
      }
    } catch (error) {
      console.error("Error fetching user details:", error.message);
      return null;
    }
  };

  const fetchMessages = async () => {
    if (!userDetails._id) return;
    setMessagesLoading(true);
    try {
      const token = localStorage.getItem("token");
      const response = await fetch(buildApiUrl(`/message/admin/all-reviews/${userDetails._id}`), {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "auth-token": token,
        },
      });

      if (response.ok) {
        const data = await response.json();
        setMessages(data);
      } else {
        console.error("Failed to fetch messages");
        setMessages([]);
      }
    } catch (error) {
      console.error("Error fetching messages:", error.message);
      setMessages([]);
    } finally {
      setMessagesLoading(false);
    }
  };

  useEffect(() => {
    const getUserDetails = async () => {
      const userData = await fetchUserDetails();
      if(localStorage.getItem("token")){
        setUserDetails(userData);
      } else {
        navigate("/login");
      }
      if (userData) {
        setUserDetails(userData);
      } else {
        setUserDetails({ name: "", email: "", id: "" });
      }
    };
    getUserDetails();
  }, [navigate]);

  return (
    <div className="info-page-wrapper">
      {/* Premium Profile Banner */}
      <div className="info-profile-banner">
        <div className="banner-overlay"></div>
        <div className="banner-content">
          <div className="profile-avatar">
            {userDetails.name ? userDetails.name.charAt(0).toUpperCase() : 'U'}
          </div>
          <div className="profile-titles">
            <h1>{userDetails.name || 'User Profile'}</h1>
            <p className="profile-role">{userDetails.role ? userDetails.role.toUpperCase() : 'MEMBER'}</p>
          </div>
        </div>
      </div>

      <div className="info-main-content">
        <div className="info-card-container">
          <div className="info-header-actions">
            <h2 className="info-section-title">Personal Information</h2>
          </div>

          {userDetails.name ? (
            <>
              <table className='user-table'>
                <tbody>
                  <tr>
                    <th>User Name</th>
                    <td>{userDetails.name}</td>
                  </tr>
                  <tr>
                    <th>Email Address</th>
                    <td>{userDetails.email}</td>
                  </tr>
                  <tr>
                    <th>Account ID</th>
                    <td>{userDetails._id}</td>
                  </tr>
                  <tr>
                    <th>Access Level</th>
                    <td>{userDetails.role}</td>
                  </tr>
                </tbody>
              </table>

              <div className="info-actions">
                <button
                  className="invoice-btn"
                  onClick={() => navigate('/user/invoices')}
                >
                  <i className="fa-solid fa-file-invoice" style={{ marginRight: '8px' }}></i>
                  My Invoices
                </button>
                <button
                  className="message-btn"
                  onClick={() => {
                    if (!showMessages && messages.length === 0) fetchMessages();
                    setShowMessages(!showMessages);
                  }}
                >
                  <i className="fa-solid fa-envelope" style={{ marginRight: '8px' }}></i>
                  {showMessages ? 'Hide Messages' : 'View Messages'}
                </button>
              </div>

              {showMessages && (
                <div className="messages-section">
                  <h2 className="info-section-title">Message History</h2>
                  {messagesLoading ? (
                    <div className="loading-state">
                      <div className="spinner"></div>
                      <p>Loading your messages...</p>
                    </div>
                  ) : messages.length > 0 ? (
                    <div className="messages-list">
                      {messages.map((msg) => (
                        <div key={msg._id} className="message-card">
                          <div className="message-header">
                            <div className="message-meta">
                              <span className="message-date">
                                <i className="fa-regular fa-calendar" style={{marginRight: '6px'}}></i>
                                {new Date(msg.date).toLocaleDateString('en-US', {
                                  year: 'numeric',
                                  month: 'short',
                                  day: 'numeric',
                                  hour: '2-digit',
                                  minute: '2-digit'
                                })}
                              </span>
                              <span className={`message-status status-${msg.status}`}>
                                {msg.status}
                              </span>
                            </div>
                          </div>
                          <div className="message-content">
                            <div className="original-message">
                              <strong>Your Inquiry</strong>
                              <p>{msg.message}</p>
                            </div>
                            {msg.replies && msg.replies.length > 0 && (
                              <div className="message-replies">
                                <strong>Support Replies</strong>
                                {msg.replies.map((reply, index) => (
                                  <div key={index} className="reply-item">
                                    <div className="reply-meta">
                                      <span className="reply-admin">
                                        <i className="fa-solid fa-headset" style={{marginRight: '6px'}}></i>
                                        {reply.adminName || 'Support Team'}
                                      </span>
                                      <span className="reply-date">
                                        {new Date(reply.date).toLocaleDateString('en-US', {
                                          year: 'numeric',
                                          month: 'short',
                                          day: 'numeric',
                                          hour: '2-digit',
                                          minute: '2-digit'
                                        })}
                                      </span>
                                    </div>
                                    <p className="reply-content">{reply.content}</p>
                                  </div>
                                ))}
                              </div>
                            )}
                          </div>
                        </div>
                      ))}
                    </div>
                  ) : (
                    <div className="empty-state">
                      <i className="fa-regular fa-comments"></i>
                      <p>No messages found in your history.</p>
                    </div>
                  )}
                </div>
              )}
            </>
          ) : (
            <div className="empty-state">
              <div className="spinner"></div>
              <p>Loading profile details...</p>
            </div>
          )}
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default Info;
